module.exports = __webpack_public_path__ + "img/eyeslash.62ac4be6.svg";